import { fetchToken } from '@agissc/ktag-map';
import { useQuery } from '@tanstack/react-query';
import currentConfig from '../../../utils/AppConfig';
import useAppState from '../../../AppStore';

interface MapFormat {
  isSupported: boolean;
  mapWidthInMillimeter: number;
  mapHeightInMillimeter: number;
}

export interface PrintLayout {
  id: string;
  displayName: string;
  formats: FormatLayout[];
}

interface FormatLayout extends PrintLayout {
  [key: string]: any;
  landscape?: MapFormat;
  portrait?: MapFormat;
}

const fetchPrintLayouts = async (isLoggeIn: boolean) => {
  const options: RequestInit = { method: 'GET' };

  if (isLoggeIn) {
    const token = await fetchToken();
    if (token) {
      options.headers = { Authorization: `Bearer ${token}` };
    }
  }

  const response = await fetch(currentConfig.apis.layouts, options);
  const result: PrintLayout[] = await response.json();
  return result;
};

const usePrintLayout = () => {
  const isLoggedIn = useAppState((state) => state.isLoggedIn);

  const queryResult = useQuery<PrintLayout[] | undefined>({
    queryKey: ['printLayers', isLoggedIn],
    queryFn: () => fetchPrintLayouts(isLoggedIn),
    gcTime: 3600000,
    staleTime: Infinity,
  });

  return queryResult;
};

export default usePrintLayout;
